// extracted by mini-css-extract-plugin
export default {"container":"hero3-module--container--p9ed1","image-wrapper":"hero3-module--image-wrapper--2Tss-","image":"hero3-module--image--hrbXC"};